import _ from 'lodash';
import config from 'config';

class FacebookAnalytics {
  constructor() {
    this.vsFacebookInit = false;
  }

  default () {
    window.dataLayer.push({ 'vsFacebookAcquisitionId': config.Analytics.facebookAcquisitionID });
  }

  vsSales(campaign) {
    let pageViewPaylod = this._pageViewPayload(campaign),
      viewContentPayload = _.clone(pageViewPaylod);

    viewContentPayload.campaign_url = `${campaign.creator.user_info.public_name}/${campaign.slug}`;

    window.dataLayer.push({ 'vsFacebookPageViewPayload': pageViewPaylod });
    window.dataLayer.push({ 'vsFacebookViewContentPayload': viewContentPayload });
    window.dataLayer.push({ 'vsFacebookPixelId': config.Analytics.facebookPixelID });

    window.dataLayer.push({ 'event': 'vs-facebook-sales-tracking' });
  }

  _globalPixelIsNotCampaignPixel(campaign) {
    return campaign.pixels.campaign.facebook.id !== campaign.pixels.global.facebook.id;
  }

  clientSales(campaign) {
    this._clientSalesHelper(campaign.pixels.campaign, campaign);

    if (this._globalPixelIsNotCampaignPixel(campaign)) {
      this._clientSalesHelper(campaign.pixels.global, campaign);
    }
  }

  _clientSalesHelper(pixels, campaign) {
    if (pixels.facebook.id) {
      let pageViewPayload = this._clientPageViewPayload(campaign),
        viewContentPayload = _.clone(pageViewPayload);

      viewContentPayload = this._mapCustomVars(viewContentPayload, pixels.facebook.custom_vars.VIEW_CONTENT);

      viewContentPayload.content_ids = [campaign.slug];
      viewContentPayload.content_type = 'product';

      window.dataLayer.push({ 'clientFacebookViewContentPayload': undefined });
      window.dataLayer.push({ 'clientFacebookPageViewPayload': pageViewPayload });
      window.dataLayer.push({ 'clientFacebookViewContentPayload': viewContentPayload });
      window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });

      window.dataLayer.push({ 'event': 'client-facebook-sales-tracking' });
    }
  }

  vsThankYou(order) {
    let pageViewPayload = this._pageViewPayload(order.campaign),
      purchasePayload = _.clone(pageViewPayload);

    purchasePayload = this._purchasePayload(order, purchasePayload, this._numItems(order));

    window.dataLayer.push({ 'vsFacebookPageViewPayload': pageViewPayload });
    window.dataLayer.push({ 'vsFacebookPurchasePayload': purchasePayload });
    window.dataLayer.push({ 'vsFacebookPixelId': config.Analytics.facebookPixelID });

    window.dataLayer.push({ 'event': 'vs-facebook-thank-you-tracking' });
  }

  clientThankYou(order) {
    this._clientThankYouHelper(order.campaign.pixels.campaign, order);

    if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
      this._clientThankYouHelper(order.campaign.pixels.global, order);
    }
  }

  _clientThankYouHelper(pixels, order) {
    if (pixels.facebook.id) {
      let pageViewPayload = this._clientPageViewPayload(order.campaign),
        purchasePayload = _.clone(pageViewPayload);

      purchasePayload = this._purchasePayload(order, purchasePayload, this._numItems(order));
      purchasePayload = this._mapCustomVars(purchasePayload, pixels.facebook.custom_vars.PURCHASE);

      purchasePayload.content_ids = [order.campaign.slug];
      purchasePayload.content_type = 'product';

      window.dataLayer.push({ 'clientFacebookPurchasePayload': undefined });
      window.dataLayer.push({ 'clientFacebookPageViewPayload': pageViewPayload });
      window.dataLayer.push({ 'clientFacebookPurchasePayload': purchasePayload });
      window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });

      window.dataLayer.push({ 'event': 'client-facebook-thank-you-tracking' });
    }
  }

  clientStore(store, storeUrl) {
    if (store.tracking_pixels.facebook) {
      let clientFacebookStorePayload = {
        content_name: store.name,
        store_url: storeUrl || '',
        content_type: 'product_group'
      };

      window.dataLayer.push({ 'clientFacebookStorePayload': clientFacebookStorePayload });
      window.dataLayer.push({ 'clientFacebookStorePixelId': store.tracking_pixels.facebook });

      window.dataLayer.push({ 'event': 'client-facebook-store-tracking' });
    }
  }

  vsAddToCart(campaign) {
    let addToCartPayload = this._pageViewPayload(campaign);

    window.dataLayer.push({ 'vsFacebookPixelId': config.Analytics.facebookPixelID });
    window.dataLayer.push({ 'vsFacebookAddToCartPayload': addToCartPayload });
  }

  clientAddToCart(campaign) {
    this._clientAddToCartHelper(campaign.pixels.campaign, campaign);

    if (this._globalPixelIsNotCampaignPixel(campaign)) {
      this._clientAddToCartHelper(campaign.pixels.global, campaign);
    }
  }

  _clientAddToCartHelper(pixels, campaign) {
    if (pixels.facebook.id) {
      let clientAddToCartPayload = this._clientPageViewPayload(campaign);
      clientAddToCartPayload = this._mapCustomVars(clientAddToCartPayload, pixels.facebook.custom_vars.ADD_TO_CART);

      clientAddToCartPayload.content_ids = [campaign.slug];
      clientAddToCartPayload.content_type = 'product';

      window.dataLayer.push({ 'clientFacebookAddToCartPayload': undefined });
      window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
      window.dataLayer.push({ 'clientFacebookAddToCartPayload': clientAddToCartPayload });

      window.dataLayer.push({ 'event': 'client-add-to-cart-tracking' });
    }
  }

  vsInitiateCheckout(campaign, numItems) {
    let initiateCheckoutPayload = this._pageViewPayload(campaign);
    initiateCheckoutPayload.num_items = numItems;

    window.dataLayer.push({ 'vsFacebookPixelId': config.Analytics.facebookPixelID });
    window.dataLayer.push({ 'vsFacebookInitiateCheckoutPayload': initiateCheckoutPayload });
  }

  clientInitiateCheckout(campaign, numItems) {
    this._clientInitiateCheckoutHelper(campaign.pixels.campaign, campaign, numItems);

    if (this._globalPixelIsNotCampaignPixel(campaign)) {
      this._clientInitiateCheckoutHelper(campaign.pixels.global, campaign, numItems);
    }
  }

  _clientInitiateCheckoutHelper(pixels, campaign, numItems) {
    if (pixels.facebook.id) {
      let clientInitiateCheckoutPayload = this._clientPageViewPayload(campaign);
      clientInitiateCheckoutPayload.num_items = numItems;
      clientInitiateCheckoutPayload = this._mapCustomVars(clientInitiateCheckoutPayload, pixels.facebook.custom_vars.INITIATE_CHECKOUT);

      window.dataLayer.push({ 'clientFacebookInitiateCheckoutPayload': undefined });
      window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
      window.dataLayer.push({ 'clientFacebookInitiateCheckoutPayload': clientInitiateCheckoutPayload });

      window.dataLayer.push({ 'event': 'client-initiate-checkout-tracking' });
    }
  }

  _purchasePayload(order, purchasePayload, numItems) {
    purchasePayload.value = `${(order.price.sub_total - order.price.coupon_discount).toFixed(2)}`;
    purchasePayload.currency = 'USD';
    purchasePayload.num_items = `${numItems}`;
    return purchasePayload;
  }

  _numItems(order) {
    let numItems = 0;
    for (var i = 0; i < order.order_products.length; i++) {
      numItems += order.order_products[i].quantity;
    }
    return numItems;
  }

  _mapCustomVars(payload, customObj) {
    _.each(customObj, customVar => payload[customVar.key] = customVar.value);
    return payload;
  }

  _pageViewPayload(campaign) {
    return {
      content_ids: [campaign.id || ''],
      content_type: 'product',
      product_category: this._getCategoryFromCampaign(campaign)
    }
  }

  _clientPageViewPayload(campaign) {
    return {
      content_name: campaign.name,
      campaign_url: `${campaign.creator.user_info.public_name}/${campaign.slug}` || '',
      product_category: this._getCategoryFromCampaign(campaign)
    }
  }

  _getCategoryFromCampaign(campaign) {
    let category;
    let hasParent = false,
      hasSub = false;

    if (campaign && campaign.category && typeof campaign.category.parent_category !== 'undefined' && campaign.category.parent_category !== null) {
      category = campaign.category.parent_category;
      hasParent = true;
    }

    if (hasParent && typeof campaign.category.name !== 'undefined' && campaign.category.name !== null) {
      category += ` > ${campaign.category.name}`;
      hasSub = true;
    }

    if (!hasParent && !hasSub) category = null;

    return category;
  }
}

export default new FacebookAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/facebook.js